module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0020.jpg?v=348073c4";